import * as Yup from 'yup';

export default Yup.object().shape({
  variant: Yup.number().nullable(),
  questions: Yup.array().of(
    Yup.object().shape({
      id: Yup.number(),
      answer: Yup.lazy((value) => {
        return typeof value === 'boolean' ? Yup.boolean().oneOf([true]) : Yup.string();
      }),
    })
  ),
});
